import React from 'react';
import {Row, Breadcrumb, BreadcrumbItem, Col, Button} from 'reactstrap';
import { Link, useHistory } from 'react-router-dom';

const NotAuthorized = () => {
    const history = useHistory();
    const back = () => {
        history.goBack();
    }
    return (
        <div>
            <Row>
                <Breadcrumb>
                    <BreadcrumbItem>
                        <Link to="/dashboard">Dashboard</Link>
                    </BreadcrumbItem>
                    <BreadcrumbItem active>Não autorizado</BreadcrumbItem>
                </Breadcrumb>
            </Row>
            <Row>
                <Col md="12">
                    <div className={"alert  alert-danger"}>
                        Seu usuário não tem permissão para acessar esta página
                        {' '}<Button onClick={()=>back()}>Voltar</Button>
                    </div>
                </Col>
            </Row>
        </div>
    );
};

export default NotAuthorized;